import React from 'react';
import { MdOutlineDateRange } from 'react-icons/md';
import bible from '../../Assets/images/bible.jpeg';
import { useFirebaseData } from '../../hooks/useFirebaseData';

export default function UpcomingEventsList({ className }) {
  const { data: eventsData, loading } = useFirebaseData('events');

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className='grid grid-cols-1 lg:grid-cols-3 gap-14 px-8 md:absolute top-72 pb-20 mb-20 z-20' id="events">
      {eventsData.map((item) => (
        <div key={item.id} className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 items-end sm:mb-[240px] md:mb-[0px] xl:mb-6'>
          <div>
            <img className='h-[270px] object-cover w-[420px]' src={bible} alt="Upcoming Events" />
          </div>
          <div className='pt-10 border h-[300px] bg-white'>
            <div className='bg-[#ffd615] w-[200px] text-white mb-4 px-4 py-1'>
              {new Date(item.startTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - {new Date(item.endTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            </div>
            <div className='px-4 mb-4'>{item.eventTitle}</div>
            <div className='flex gap-2 mb-4 px-4'>
              <div className='mt-1 text-[#a69ba3]'><MdOutlineDateRange /></div>
              <div className='text-[#a69ba3]'>{new Date(item.startTime).toLocaleDateString()}</div>
            </div>
            <div className='text-[#a69ba3] px-4 mb-4'>{item.eventDescription}</div>
            <div className='px-4'>
              <button className='bg-[#ffd615] text-white rounded-full px-5 py-2'>Join Us</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
